import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { CountUp } from 'countup.js';

gsap.registerPlugin(ScrollTrigger);

export function flxStats() {
    const stats = document.querySelectorAll('.stat-number__value');

    if (!stats) {
        return;
    }

    // Numbers
    stats.forEach((stat) => {
        let value = stat.dataset.statValue;
        let countUp = new CountUp(stat, value);

        ScrollTrigger.create({
            trigger: stat,
            start: 'top 75%',
            onEnter: () => {
                countUp.start();
            }
        });
    });
}
